export * from './timeline.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/release/common/timeline/index.js
// module id = 1450
// module chunks = 3